import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { AuthProvider } from "@/auth/AuthProvider";
import AuthCallback from "@/auth/AuthCallback";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LandingPage from "@/pages/LandingPage";
import BuilderPage from "@/pages/BuilderPage";
import MarketplacePage from "@/pages/MarketplacePage";
import DashboardPage from "@/pages/DashboardPage";
import AgentChatPage from "@/pages/AgentChatPage";
import BriefTrackPage from "@/pages/BriefTrackPage";
import LoginPage from "@/pages/LoginPage";

function AppRoutes() {
  const location = useLocation();
  // Process Emergent Google OAuth callback (?#session_id=...) synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/build" element={<BuilderPage />} />
          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/agent/:id" element={<AgentChatPage />} />
          <Route path="/brief/:id" element={<BriefTrackPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
